<template>
  <el-dialog
    title="自动生成"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="content">
      <el-input size="small" placeholder="请输入密码" v-model="input" show-password></el-input>
      <el-button type="primary" size="small" @click="confirm">确认生成</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "NoticeTemplateCreate",
  components: {},
  props: {
    addResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      input: "",
      passwordDefault: "newbool123"
    };
  },
  created() {
    
  },
  mounted() {},
  watch: {
    addResize: function(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.clearData();
    },
    clearData() {
      this.input = "";
    },
    confirm() {
      if(this.input != this.passwordDefault) {
        this.$message("请输入正确的密码！");
        return;
      }
      this.createTemplate();
    },
    async createTemplate() {
      let req = {
        schoolIdList: [this.$store.state.schoolId]
      };
      const loading = this.$loading({
        lock: true,
        text: "生成中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.createNoticesTemplate(req);
      loading.close();
      if (res.code == 200) {
        this.$message({
          showClose: true,
          type: "success",
          message: "生成成功！"
        });
      } else {
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .user {
    font-size: 14px;
    text-align: right;
  }
  .info {
    font-size: 14px;
    text-indent: 30px;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
